module.exports = __webpack_public_path__ + "img/29_9.2d07e2c0.png";